

import { configureStore } from "@reduxjs/toolkit";

import States from "./PHPSlice/States";
import Party from "./PHPSlice/Party";
import Item from "./PHPSlice/Item";
import zone from "./PHPSlice/zone";
import LocationApi from "./PHPSlice/LocationApi";
import sktInw from "./PHPSlice/StkInw";
import stockApi from "./PHPSlice/stockApi";
import Firm, { createFirmEntry } from "./PHPSlice/Firm";
import userReturn from "./PHPSlice/Return";


export const store = configureStore({
    reducer: {

        StatesData: States,
        PartyData: Party,
        ItemData: Item,
        ZoneData: zone,
        LocationData: LocationApi,
        stkInwData: sktInw,
        stockData: stockApi,
        FirmData: Firm,
        userReturn: userReturn,

    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Disable the serializable state invariant middleware
            immutableCheck: false,
        }),
});


